module.exports = __webpack_public_path__ + "img/third-onboarding.d2c82d5d.png";